import { getUtiqHost } from './utiq-config';

const UTIQ_PURPOSE_ID = 'Utiq';
const UTIQ_VENDOR_ID = 'V1';

let utiqHost = '';

function isUserConsentGranted() {
    if (!window.Optanon?.IsAlertBoxClosed?.()) {
        return undefined;
    }
    if (typeof window.OptanonActiveGroups !== 'string' || window.OptanonActiveGroups === '') {
        return undefined;
    }
    return (
        window.OptanonActiveGroups.indexOf(UTIQ_PURPOSE_ID) !== -1 &&
        window.OptanonActiveGroups.indexOf(UTIQ_VENDOR_ID) !== -1
    );
}

function updateConsent(isUtiqConsentGranted) {
    const cmpConsentGranted = isUserConsentGranted();
    if (isUtiqConsentGranted === false && cmpConsentGranted === true) {
        window.Optanon?.UpdateConsent('Category', `${UTIQ_PURPOSE_ID}:0`);
        window.Optanon?.UpdateConsent('General Vendor', `${UTIQ_VENDOR_ID}:0`);
    } else if (isUtiqConsentGranted === true && cmpConsentGranted === false) {
        window.Optanon?.UpdateConsent('Category', `${UTIQ_PURPOSE_ID}:1`);
        window.Optanon?.UpdateConsent('General Vendor', `${UTIQ_VENDOR_ID}:1`);
    } else if (isUtiqConsentGranted === undefined && cmpConsentGranted !== undefined) {
        window.Utiq?.API?.handleConsentChange(cmpConsentGranted);
    }
}

function loadUtiqScript() {
    if (window.utiqScriptLoaded) return;
    window.utiqScriptLoaded = true;

    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = `https://${utiqHost}/utiqLoader.js`;
    s.async = true;
    document.head.appendChild(s);
}

export function initUtiqWithConsent(domain) {
    utiqHost = getUtiqHost(domain);
    window.Utiq ||= {};
    window.Utiq.queue ||= [];

    window.Utiq.queue.push(() => {
        setTimeout(() => {
            window.Optanon?.OnConsentChanged?.(() => {
                const optanonConsent = isUserConsentGranted();
                if (
                    window.Utiq.API.getUtiqConsentStatus() === undefined ||
                    optanonConsent !== undefined
                ) {
                    window.Utiq.API.handleConsentChange(optanonConsent, {
                        syncConsentOnAccept: Boolean(optanonConsent),
                    });
                }
            });

            updateConsent(window.Utiq.API.getUtiqConsentStatus());

            window.Utiq.API.addEventListener('onConsentUpdateFinished', ({ isConsentGranted }) => {
                updateConsent(isConsentGranted);
            });
        }, 1000);
    });

    window.Utiq.config = {
        CMP: 'none',
    };

    loadUtiqScript();
}
